import { CSSProperties, ReactNode } from "react";
import styles from "./Heading.module.css";
import { useNavigate } from "react-router";
import Icon from "../../Icon";

export default function Heading({ children }: { children: ReactNode }) {
  return <div className={styles["heading"]}>{children}</div>;
}

function Title({
  children,
  hasBackButton,
  to,
  backToScreenSteps = -1,
  onBackClick,
}: {
  children: ReactNode;
  hasBackButton?: boolean;
  to?: string;
  backToScreenSteps?: number;
  onBackClick?: () => void;
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      // 👇 default navigation logic
      to ? navigate(to, { replace: true }) : navigate(backToScreenSteps);
    }
  };

  return (
    <div className={styles["heading_title"]}>
      {hasBackButton && (
        <button
          title="back button"
          type="button"
          className={styles["heading_back_button"]}
          onClick={handleBack}
        >
          <Icon name="back" iconAs="icon" />
        </button>
      )}
      {children}
    </div>
  );
}

function HeadingButton({ children, customStyles }: { children: ReactNode, customStyles?: CSSProperties }) {
  return <div className={styles["heading_button"]} style={customStyles}>{children}</div>;
}

Heading.Title = Title;
Heading.Button = HeadingButton;
